import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { setlocal } from '@src/utils/index';

const Success = ({ updateId }) => {
    const tipText = updateId ? '導演組已經收到你更新的資料啦！' : '導演組已經收到你的資料啦！';

    useEffect(() => {
        setlocal('img1FormBase64Url', null);
        setlocal('img2FormBase64Url', null);
        setlocal('formData', null);
        // setlocal('submitSucess', 1);

        setTimeout(() => {
            location.href = location.href.includes('from_wecom=1') ? location.href : `${location.href}?from_wecom=1`;
        }, 5000);
    }, []);
    
    return (
        <div className={styles.success}>
            <div className={styles.successBox}>{tipText}<br />我們會飛快查看並第一時間聯系您哦~</div>
            <div className={styles.successCallback}>問題回饋：wangning11@ifeng.com</div>
        </div>
    );
};

Success.propTypes = {
    updateId: PropTypes.string,
};

export default errorBoundary(Success);
